<template>
  <div id="screen" class="component-screen footer-hidden m-0 p-0">
    <Loader v-if="loading" cover/>
    <div v-else class="vx-row lg:h-full m-0">
      <div class="vx-col panels main-panel overflow-x-hidden lg:h-full sm:h-1/2 flex-1 sm:w-1/1 p-0 bg-white">
        <div class="vx-row">
          <MainPanel
            :countLearningPercent="countLearningPercent"
            :currentCourseOutlineUnit="currentCourseOutlineUnit"
            :currentStudentUnitTest="currentStudentUnitTest"
            :currentVdoSetTopic="currentVdoSetTopic"
            :examMode="examMode"
            :isBigScreen="isBigScreen"
            :keepCounting="keepCounting"
            :forceStopVideo="forceStopVideo"

            :mainPanelMode="mainPanelMode"
            :setDoingExam="setDoingExam"
            :setNewStudentUnitTestToCourseOutlineUnits="setNewStudentUnitTestToCourseOutlineUnits"
            :setTriggerLoading="setTriggerLoading"
            :sidePanelActive="sidePanelActive"
            :startLearning="startLearning"
            :studentEnrollDetail="studentEnrollDetail"

            :toggleSidePanel="toggleSidePanel"
            @onVideoStopped="saveCurrentProgress"
          >
          </MainPanel>
        </div>

        <div class="vx-row">
          <BottomPanel :class-section="classSection"
                       :course-outline-units="courseOutlineUnits"
                       :courseOutlineUnitLoading="courseOutlineUnitLoading"
                       :currentCourseOutlineUnit="currentCourseOutlineUnit"
                       :handlerStartTestClick="handlerStartTestClick"
                       :handlerTopicClick="handlerTopicClick"

                       :isBigScreen="isBigScreen"
                       :sidePanelActive="sidePanelActive"
                       :student="student"
                       :student-enroll-detail="studentEnrollDetail"
                       :teacher="teacher"
                       :triggerLoading="triggerLoading"
                       @toggleSidePanel="toggleSidePanel"
          >
          </BottomPanel>
        </div>
      </div>

      <SidePanel v-if="isBigScreen"
                 :courseOutlineUnitLoading="courseOutlineUnitLoading"
                 :courseOutlineUnits="courseOutlineUnits"
                 :handlerStartTestClick="handlerStartTestClick"
                 :handlerTopicClick="handlerTopicClick"
                 :sidePanelActive="sidePanelActive"
                 :student-enroll-detail="studentEnrollDetail"
                 :triggerLoading="triggerLoading"
                 @toggleSidePanel="toggleSidePanel"
      >
      </SidePanel>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import EventBus from '@/event-bus';

import MainPanel from "./MainPanel";
import SidePanel from "./SidePanel";
import BottomPanel from "./BottomPanel";
import StudentEnrollDetail from "@/store/modules/student-enroll/student-enroll-detail";
import StudentUnitTest from "@/store/modules/student-unittest";
import StudentUnitLearn from "@/store/modules/student-unit-learn";
import {createNamespacedHelpers} from "vuex";
import Swal from 'sweetalert2'
import {creditLearnTime} from "@/utils/learn-time";
import {learnOwnerStatus, unsavedLearnTimeKey} from "@/utils/unsaved-learn-time";

if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);
if (!store.state.StudentUnitTest) store.state.registerModule(`StudentUnitTest`, StudentUnitTest);
if (!store.state.StudentUnitLearn) store.state.registerModule(`StudentUnitLearn`, StudentUnitLearn);

const {
  mapActions: mapStudentEnrollDetailActions,
} = createNamespacedHelpers(`StudentEnrollDetail`);
const {
  mapActions: mapStudentUnitTestActions,
} = createNamespacedHelpers(`StudentUnitTest`);
const {
  mapActions: mapStudentUnitLearnActions,
} = createNamespacedHelpers(`StudentUnitLearn`);

export default {
  components: {
    MainPanel,
    SidePanel,
    BottomPanel,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  computed: {
    student() {
      if (this.studentEnrollDetail) {
        return this.studentEnrollDetail.student;
      }
      return null;
    },
    teacher() {
      if (this.studentEnrollDetail) {
        return this.studentEnrollDetail.courseOutlineRegistration.teacher;
      }
      return null;
    },
    classSection() {
      if (this.studentEnrollDetail) {
        return this.studentEnrollDetail.classSection;
      }
      return null;
    },
  },
  data() {
    return {
      loading: true,
      courseOutlineUnitLoading: true,
      studentEnrollDetailId: null,
      studentEnrollDetail: null,
      courseOutlineUnits: [],
      sidePanelActive: true,

      //FOR VIDEO PANEL
      currentVdoSetTopic: null,
      currentVdoSetTopicIndex: null,
      keepCounting: true,
      secondToUpdateStudentLearnTime: 10,
      secondsSinceSave: 0,
      forceStopVideo: false,

      //FOR PRE & POST TEST PANEL
      doingExam: false,
      examMode: '',
      currentStudentUnitTest: null,
      currentStudentUnitTestIndex: null,
      studentUnitPreTests: [],
      studentAnswers: [],

      //FOR VIDEO & PRE & POST TEST PANEL
      mainPanelMode: 'cover',
      currentCourseOutlineUnit: null,
      currentCourseOutlineUnitIndex: null,
      triggerLoading: false,

      isBigScreen: true,
    }
  },
  methods: {
    ...mapStudentEnrollDetailActions({
      getStudentEnrollDetailByIdForLearning: 'getStudentEnrollDetailByIdForLearning',
    }),
    ...mapStudentUnitTestActions({
      addStudentUnitTest: 'addStudentUnitTest',
    }),
    ...mapStudentUnitLearnActions({
      addStudentUnitLearnAndTopic: 'addStudentUnitLearnAndTopic',
      addStudentTopicLearn: 'addStudentTopicLearn',
      updateStudentTopicAndUnitLearn: 'updateStudentTopicAndUnitLearn',
      checkUnsavedLearnTime: 'checkUnsavedLearnTime',
    }),
    //---------------------------------- VDO PANEL FUNCTION ----------------------------------
    async countLearningPercent(seconds) {
      // seconds: what MainPanelVdo's learn-time meter credited since its last
      // call -- usually 1, a whole minute after a throttled hidden tab.
      const {learnTime, percent} = creditLearnTime(
        this.currentVdoSetTopic.studentTopicLearn.learnTime,
        this.currentVdoSetTopic.vdoLength,
        seconds,
      );

      //set new percent to studentTopicLearn in courseOutlineUnit
      this.setNewLearnTimeToCourseOutlineUnit(learnTime, percent);
      this.secondsSinceSave += seconds;
      if (percent >= 100) {
        //update StudentTopicLearnTime and stop counting
        this.keepCounting = false;
        this.secondsSinceSave = 0;
        await this.updateStudentTopicLearnTime();
      } else if (this.secondsSinceSave >= this.secondToUpdateStudentLearnTime) {
        //update StudentTopicLearnTime every 10 credited seconds
        this.secondsSinceSave = 0;
        await this.updateStudentTopicLearnTime();
      }
    },
    setNewLearnTimeToCourseOutlineUnit(newLearnTime, percent) {
      //update student Topic Learn
      if(this.currentVdoSetTopic.studentTopicLearn.learnTime <= newLearnTime){
        this.currentVdoSetTopic.studentTopicLearn.learnTime = newLearnTime;
        this.currentVdoSetTopic.studentTopicLearn.learnPercent = percent;

        this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit
          .vdoSetTopics[this.currentVdoSetTopicIndex]
          .studentTopicLearn.learnTime = newLearnTime;
        this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit
          .vdoSetTopics[this.currentVdoSetTopicIndex]
          .studentTopicLearn.learnPercent = percent;

        // update student Unit
        // new
        let newUnitLearnTime = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit
          .vdoSetTopics.map(item => {
            return item.studentTopicLearn.learnTime
          })
          .reduce((a, b) => a + b, 0);
        // console.log('newUnitLearnTime',newUnitLearnTime);
        let totalUnitVdoLength = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit
          .vdoSetTopics.map(item => {
            return item.studentTopicLearn.vdoLength
          })
          .reduce((a, b) => a + b, 0);
        // console.log('totalUnitVdoLength',totalUnitVdoLength);

        // old
        /*let totalUnitVdoLength = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .vdoSetUnit.totalVdoLength;
        let newUnitLearnTime = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .studentUnitLearn.totalLearnTime + 1;*/

        if (newUnitLearnTime > totalUnitVdoLength) {
          newUnitLearnTime = totalUnitVdoLength;
        }

        let unitPercent = Math.floor((newUnitLearnTime / totalUnitVdoLength) * 100);
        if (unitPercent > 100) {
          unitPercent = 100;
        }

        // console.log('unitPercent', unitPercent);

        this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .studentUnitLearn.totalLearnTime = newUnitLearnTime;
        this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
          .studentUnitLearn.learnPercent = unitPercent;
      }

    },
    async updateStudentTopicLearnTime() {
      // Another student signed in on this browser after this page loaded:
      // this save would go out with their token onto this enrollment.
      if (this.currentLearnOwner() === 'different') {
        this.stopForAnotherStudent();
        return;
      }
      const studentTopicLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit
        .vdoSetTopics[this.currentVdoSetTopicIndex]
        .studentTopicLearn;
      const studentUnitLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex].studentUnitLearn;

      const payload = {
        studentTopicLearnId: studentTopicLearn.id,
        studentUnitLearnId: studentUnitLearn.id,
        studentTopicLearnInput: {
          learnTime: studentTopicLearn.learnTime,
          learnPercent: studentTopicLearn.learnPercent,
        },
        studentUnitLearnInput: {
          totalLearnTime: studentUnitLearn.totalLearnTime,
          learnPercent: studentUnitLearn.learnPercent,
        },
      }
      const result = await this.updateStudentTopicAndUnitLearn(payload);
      if (!result) {
        this.saveUnsavedItems(payload);
        this.forceRefresh();
      }else if(result.forceUpdateFrontLearnTime){
        //update learn time to match DB
        this.setNewLearnTimeToCourseOutlineUnit(result.learnTime, result.learnPercent)
      }
    },
    buildCurrentLearnPayload() {
      if (this.currentCourseOutlineUnitIndex === null || this.currentVdoSetTopicIndex === null) {
        return null;
      }
      const studentTopicLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex]
        .vdoSetUnit
        .vdoSetTopics[this.currentVdoSetTopicIndex]
        .studentTopicLearn;
      const studentUnitLearn = this.courseOutlineUnits[this.currentCourseOutlineUnitIndex].studentUnitLearn;
      return {
        studentTopicLearnId: studentTopicLearn.id,
        studentUnitLearnId: studentUnitLearn.id,
        studentTopicLearnInput: {
          learnTime: studentTopicLearn.learnTime,
          learnPercent: studentTopicLearn.learnPercent,
        },
        studentUnitLearnInput: {
          totalLearnTime: studentUnitLearn.totalLearnTime,
          learnPercent: studentUnitLearn.learnPercent,
        },
      };
    },
    saveCurrentProgress() {
      const payload = this.buildCurrentLearnPayload();
      if (payload) {
        this.saveUnsavedItems(payload);
      }
    },
    saveUnsavedItems(payload){
      //save to local storage
      // Only under the owner's own key, and only while the owner is the one
      // signed in: the replay sends it with whatever token is current.
      if (this.currentLearnOwner() !== 'same') {
        return;
      }
      const key = unsavedLearnTimeKey(this.studentEnrollDetail.student.code);

      let unSavedItems = localStorage.getItem(key);

      if(unSavedItems){
        unSavedItems = JSON.parse(unSavedItems);
      }else{
        unSavedItems = {};
      }

      const objKey = payload.studentUnitLearnId+'_'+payload.studentTopicLearnId;
      if( objKey in unSavedItems ){
        if( payload.studentTopicLearnInput.learnTime > unSavedItems[objKey].studentTopicLearnInput.learnTime){
          unSavedItems[objKey] = {
            ...payload
          };
          localStorage.setItem(key, JSON.stringify(unSavedItems));
        }
      }else{
        unSavedItems[objKey] = {
          ...payload
        };
        localStorage.setItem(key, JSON.stringify(unSavedItems));
      }
    },
    currentLearnOwner() {
      const student = this.studentEnrollDetail && this.studentEnrollDetail.student;
      return learnOwnerStatus(student && student.code);
    },
    stopForAnotherStudent() {
      this.forceStopVideo = true;
      Swal.fire({
        title: this.$t('virtual-class.another-student-title'),
        text: this.$t('virtual-class.another-student-message'),
        icon: 'warning',
        confirmButtonText: this.$t('general.close'),
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        // A full reload, so nothing of the previous student stays in memory.
        window.location = process.env.BASE_URL;
      });
    },
    forceRefresh(){
      //stop video
      this.forceStopVideo = true;

      //alert and refresh
      Swal.fire({
        title: this.$t('virtual-class.can-not-save-learn-time-title'),
        text: this.$t('virtual-class.can-not-save-learn-time-message'),
        icon: 'error',
        confirmButtonText: 'Refresh',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
      }).then(() => {
        location.reload();
      })
    },
    //---------------------------------- PRE & POST TEST PANEL FUNCTION ----------------------------------
    handlerStartTestClick({unit, examMode}) {

      if (this.examMode !== examMode
        || !this.currentStudentUnitTest
        || this.currentStudentUnitTest.id !== unit.studentUnitTest.id) {
        if (this.doingExam) {
          const acceptLost = confirm(this.$t(`virtual-class.confirm-quit-${examMode}`));
          if (acceptLost === true) {
            this.clearVdoPanelVariable();
            this.currentCourseOutlineUnit = unit;
            this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
            this.currentStudentUnitTest = unit.studentUnitTest;
            this.mainPanelMode = 'test'
            this.examMode = examMode;
            /*this.setCurrentCourseOutlineUnit(unit);
            this.setCurrentStudentUnitTest(unit);
            this.startPretest();*/
          }
        } else {
          this.clearVdoPanelVariable();
          this.currentCourseOutlineUnit = unit;
          this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
          this.currentStudentUnitTest = unit.studentUnitTest;
          this.mainPanelMode = 'test'
          this.examMode = examMode;
          /*this.setCurrentCourseOutlineUnit(unit);
          this.setCurrentStudentUnitTest(unit);
          this.startPretest();*/
        }

      } /*else {
        console.log('dup')
      }*/

    },
    startLearning(unit) {
      let firstTopic = unit.vdoSetUnit.vdoSetTopics;
      if (firstTopic && firstTopic.length > 0) {
        this.handlerTopicClick({unit, topic: firstTopic[0]});
      }
    },
    setDoingExam(doingExam) {
      this.doingExam = doingExam;
    },
    setNewStudentUnitTestToCourseOutlineUnits(studentUnitTest) {
      this.currentCourseOutlineUnit.studentUnitTest = studentUnitTest;
      this.currentStudentUnitTest = studentUnitTest;

      this.courseOutlineUnits[this.currentCourseOutlineUnitIndex].studentUnitTest = studentUnitTest;
    },
    //---------------------------------- SIDE PANEL FUNCTION ----------------------------------
    toggleSidePanel(toggle) {
      this.sidePanelActive = toggle;
    },
    handlerTopicClick({topic, unit}) {
      // console.log('unit',unit);
      // console.log('topic',topic);
      this.saveCurrentProgress(); // save current topic progress before switching
      this.clearUniTestPanelVariable();
      //set current currentCourseOutlineUnit && currentVdoSetTopic
      this.setCurrentCourseOutlineUnit(unit);
      this.setCurrentVdoSetTopic(topic);
      this.secondsSinceSave = 0;

      //if complete learning then dont count percent
      if (this.currentVdoSetTopic.vdoLength > this.currentVdoSetTopic.studentTopicLearn.learnTime) {
        this.keepCounting = true;
      } else {
        this.keepCounting = false;
      }
      // console.log('keepCounting', this.keepCounting)

      //show video panel
      this.mainPanelMode = 'vdo';
    },
    //---------------------------------- LOCAL FUNCTION ----------------------------------
    async loadData() {
      this.loading = true;
      await this.checkUnsavedLearnTime();
      if (this.$route.params.studentEnrollDetailId) {
        this.studentEnrollDetailId = this.$route.params.studentEnrollDetailId;
        this.studentEnrollDetail = await this.getStudentEnrollDetailByIdForLearning({id: this.studentEnrollDetailId});
        if (this.studentEnrollDetail) {
          this.courseOutlineUnitLoading = true;
          this.courseOutlineUnits = await this.prepareCourseOutlineUnits();
          this.courseOutlineUnitLoading = false;
        }
      }
      this.loading = false;
    },
    async prepareCourseOutlineUnits() {
      //create Course Outline Units for Side Panel
      let newCourseOutlineUnits = [];
      let courseOutlineUnits = this.studentEnrollDetail
        .courseOutlineRegistration
        .courseOutline
        .courseOutlineUnits;
      if (courseOutlineUnits && courseOutlineUnits.length > 0) {
        let studentUnitTests = this.studentEnrollDetail.studentUnitTests;
        let studentUnitLearns = this.studentEnrollDetail.studentUnitLearns;
        let vdoSetUnits = [];
        if (this.studentEnrollDetail.classSection.vdoSet) {
          vdoSetUnits = this.studentEnrollDetail.classSection.vdoSet.vdoSetUnits;
        }
        for (let i = 0; i < courseOutlineUnits.length; i++) {
          const item = courseOutlineUnits[i];
          let vdoSetUnit = vdoSetUnits.find(element =>
            element.courseOutlineUnit && element.courseOutlineUnit.id === item.id);

          //filter isEnabled vdoSetTopic
          if(vdoSetUnit && vdoSetUnit.vdoSetTopics && vdoSetUnit.vdoSetTopics.length > 0) {
            vdoSetUnit.vdoSetTopics = vdoSetUnit.vdoSetTopics.filter(e => e.isEnabled);
          }

          //check Student Unit Test
          let studentUnitTest = studentUnitTests.find(element =>
            element.courseOutlineUnit && element.courseOutlineUnit.id === item.id);
          if (!studentUnitTest && item.countLearnPercent) {
            //create missing studentUnitTest
            studentUnitTest = await this.createStudentUnitTests(item);
          }
          //check Student Unit Learn
          //course outline unit and vdo set unit must match
          let studentUnitLearn = studentUnitLearns.find(element =>
            element.courseOutlineUnit && element.vdoSetUnit
            && element.courseOutlineUnit.id === item.id
            && element.vdoSetUnit.id === vdoSetUnit.id);
          if (!studentUnitLearn && vdoSetUnit) {
            //create missing studentUnitLearn
            studentUnitLearn = await this.createStudentUnitLearns(item, vdoSetUnit);
            vdoSetUnit = await this.setStudentTopicLearnToVdoSetTopic(studentUnitLearn, vdoSetUnit);
          }
          else if (vdoSetUnit && vdoSetUnit.vdoSetTopics && vdoSetUnit.vdoSetTopics.length > 0) {
            //check and set Student Topic Learn to Vdo Set Topic
            vdoSetUnit = await this.setStudentTopicLearnToVdoSetTopic(studentUnitLearn, vdoSetUnit);
          }

          let result = {
            ...item,
            studentUnitTest,
            studentUnitLearn,
            vdoSetUnit,
          }
          newCourseOutlineUnits.push(result);
        }
      }
      return newCourseOutlineUnits;
    },
    async createStudentUnitTests(courseOutlineUnit) {
      const payload = {
        studentId: this.studentEnrollDetail.student.id,
        courseOutlineUnitId: courseOutlineUnit.id,
        studentEnrollId: this.studentEnrollDetail.studentEnroll.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        academicPeriodId: this.studentEnrollDetail.studentEnroll.academicPeriod.id,
        subjectId: this.studentEnrollDetail.subject.id,
        studentUnitTestInput: {
          studentCode: this.studentEnrollDetail.student.code,
          subjectCode: this.studentEnrollDetail.subject.code,
          periodCode: this.studentEnrollDetail.studentEnroll.periodCode,

          unitSeq: courseOutlineUnit.seq,
          pretestScore: 0,
          pretestMaxScore: courseOutlineUnit.preTestExpectScore,
          pretestQuestionQty: courseOutlineUnit.preTestExpectScore,
          isPretestDone: false,
          posttestScore: 0,
          posttestMaxScore: courseOutlineUnit.postTestExpectScore,
          posttestQuestionQty: courseOutlineUnit.postTestExpectScore,
          isPosttestDone: false,
        },
      };
      let result = await this.addStudentUnitTest(payload);
      if (result) {
        return result;
      }
      return null;
    },
    async createStudentUnitLearns(courseOutlineUnit, vdoSetUnit) {
      const payload = {
        studentEnrollId: this.studentEnrollDetail.studentEnroll.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: courseOutlineUnit.id,
        vdoSetUnitId: vdoSetUnit.id,
        studentUnitLearnInput: {
          unitSeq: courseOutlineUnit.seq,
          totalVdoLength: vdoSetUnit.totalVdoLength,
          totalLearnTime: 0,
          learnPercent: 0,
        },
      };
      let result = await this.addStudentUnitLearnAndTopic(payload);
      if (result) {
        return result;
      }
      return null;
    },
    async createStudentTopicLearn(studentUnitLearn, vdoSetTopic, vdoSetUnit) {

      let learnTime = 0;
      let learnPercent = 0;
      //fix case have Student unit learn percent = 100 but dont have student topic learn
      // if (studentUnitLearn.learnPercent >= 100) {
      //   learnTime = vdoSetTopic.vdoLength;
      //   learnPercent = 100;
      // }
      const payload = {
        studentUnitLearnId: studentUnitLearn.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        vdoSetUnitId: vdoSetUnit.id,
        vdoSetTopicId: vdoSetTopic.id,
        studentTopicLearnInput: {
          vdoLength: vdoSetTopic.vdoLength,
          learnTime: learnTime,
          learnPercent: learnPercent,
        }
      };
      const result = await this.addStudentTopicLearn(payload);
      if (result) {
        return result
      }
      return null
    },
    setCurrentCourseOutlineUnit(unit) {
      this.currentCourseOutlineUnit = unit;
      this.currentCourseOutlineUnitIndex = this.courseOutlineUnits.findIndex(item => item.id === unit.id);
    },
    setCurrentVdoSetTopic(topic) {
      this.currentVdoSetTopic = topic;
      this.currentVdoSetTopicIndex = this.currentCourseOutlineUnit
        .vdoSetUnit
        .vdoSetTopics.findIndex(item => item.id === topic.id);
    },
    async setStudentTopicLearnToVdoSetTopic(studentUnitLearn, vdoSetUnit) {
      if(studentUnitLearn){
        let studentTopicLearns = studentUnitLearn.studentTopicLearns;
        for (let j = 0; j < vdoSetUnit.vdoSetTopics.length; j++) {
          let vdoSetTopic = vdoSetUnit.vdoSetTopics[j];
          let studentTopicLearn = studentTopicLearns.find(element =>
            element.vdoSetTopic && element.vdoSetTopic.id === vdoSetTopic.id);
          if (!studentTopicLearn) {
            //create missing studentTopicLearn
            studentTopicLearn = await this.createStudentTopicLearn(studentUnitLearn, vdoSetTopic, vdoSetUnit);
          }
          vdoSetUnit.vdoSetTopics[j] = {
            ...vdoSetUnit.vdoSetTopics[j],
            studentTopicLearn,
          }
        }
      }
      return vdoSetUnit;
    },
    clearVdoPanelVariable() {
      this.currentVdoSetTopic = null;
      this.currentVdoSetTopicIndex = null;
      this.keepCounting = false;
    },
    clearUniTestPanelVariable() {
      this.doingExam = false;
      this.examMode = '';
      this.currentStudentUnitTest = null;
      this.currentStudentUnitTestIndex = null;
    },
    setTriggerLoading(val) {
      this.triggerLoading = val
    },
    handleWindowResize(event) {
      if (event && !event.isTrusted) {
        return;
      }
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1200) {
        this.isBigScreen = false;
      } else {
        this.isBigScreen = true;
      }
    },
  },
  async beforeMount() {
    EventBus.$emit('toggleNav', 'close');
    await this.loadData();
  },
  async mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
    window.addEventListener('beforeunload', this.saveCurrentProgress);
  },
  beforeRouteLeave(to, from, next) {
    this.saveCurrentProgress();
    next();
  },
  async beforeDestroy() {
    document.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('beforeunload', this.saveCurrentProgress);
  },
}
</script>

<style lang="scss">
#screen {
  @media only screen and (min-width: 1024px) {
    height: calc(var(--vh, 1vh) * 100 - 6rem) !important;
  }
  word-break: break-word !important;
  overflow: hidden;

  & .panels {
    overflow-y: auto;
  }
}

.parentx-static {
  overflow: hidden;
  position: relative;
}

.content-tab-button {
  position: absolute;
  top: 36px;
  right: -6px;
  transition: all ease-in 300ms;
  z-index: 99999;

  & .vs-button-text {
    display: inline-flex;
    align-items: center;
  }

  &.hide {
    right: -114px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

.main-panel {
  border-left: 1px solid #eeeeee !important;
  border-right: 1px solid #dddddd !important;
}

.side-panel {
  transition: all ease-out 400ms;
  // width: 0px;

  &.hide {
    width: 0px !important;
    opacity: 0;
  }
}

.panel-fade-enter-active {
  transition: all .3s ease;
}

.panel-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.panel-fade-enter, .panel-fade-leave-to {
  opacity: 0;
}

</style>
